import { postData } from '../plugins/ApiCalls'

export function saveOnboardingData(data) {
  return postData('onboarding-data', data)
}

export function saveOnboardingFlag(data) {
  return postData('onboarding', data)
}
